var a = Object.defineProperty;
var p = (o, t, i) => t in o ? a(o, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : o[t] = i;
var e = (o, t, i) => p(o, typeof t != "symbol" ? t + "" : t, i);
var n = /* @__PURE__ */ ((o) => (o.NAVIGATE_NEXT = "navigateNext", o.NAVIGATE_BACK = "navigateBack", o))(n || {});
class s {
  constructor(t) {
    e(this, "microApp");
    this.microApp = t;
  }
  next() {
    var t;
    (t = this.microApp) == null || t.dispatch({ type: n.NAVIGATE_NEXT });
  }
  back() {
    var t;
    (t = this.microApp) == null || t.dispatch({ type: n.NAVIGATE_BACK });
  }
}
class w {
  get path() {
    return new URL(window.rawWindow.location.href).searchParams.get(window.__MICRO_APP_NAME__);
  }
  push(t) {
    const i = new URL(window.rawWindow.location.href);
    i.searchParams.set(window.__MICRO_APP_NAME__, t), window.rawWindow.history.pushState({}, "", i.toString()), window.rawWindow.dispatchEvent(new PopStateEvent("popstate"));
  }
}
class r {
  constructor() {
    e(this, "microApp");
    e(this, "navigation");
    e(this, "subRoute");
    if (!r.supported)
      throw new Error("MicroBridge is not supported");
    this.microApp = window.microApp, this.navigation = new s(this.microApp), this.subRoute = new w();
  }
  static get supported() {
    return typeof window < "u" && typeof window.microApp < "u";
  }
  static create() {
    return new r();
  }
}
export {
  n as MicroEvent,
  r as default
};
//# sourceMappingURL=micro-bridge.js.map
